import { createContext, useContext } from 'react';

interface AdminNavContextValue {
	closeMobileNav: () => void;
}

const AdminNavContext = createContext<AdminNavContextValue | null>(null);

export const AdminNavProvider = AdminNavContext.Provider;

export function useAdminNav() {
	const context = useContext(AdminNavContext);
	if (!context) {
		throw new Error('useAdminNav must be used within AdminNavProvider');
	}
	return context;
}
